import { api } from "@/lib/api";
import type { ApiResponse, Course } from "@learn-me/types";

export interface WishlistItem {
  id: string;
  addedAt: string;
  course: {
    id: string;
    title: string;
    slug: string;
    shortDescription?: string;
    thumbnailUrl?: string;
    isFree: boolean;
    listPrice?: number | null;
    salePrice?: number | null;
    hasDiscount: boolean;
    currency: string;
    level?: string;
    duration?: number;
    chaptersCount: number;
    studentsCount: number;
  };
}

export const wishlistApi = {
  async getWishlist(): Promise<WishlistItem[]> {
    const response = await api.get<ApiResponse<WishlistItem[]>>("/wishlist");
    return response.data.data!;
  },

  async addToWishlist(
    courseId: string,
  ): Promise<{ id: string; addedAt: string; course: Partial<Course> }> {
    const response = await api.post<
      ApiResponse<{ id: string; addedAt: string; course: Partial<Course> }>
    >("/wishlist", { courseId });
    return response.data.data!;
  },

  async removeFromWishlist(courseId: string): Promise<void> {
    await api.delete(`/wishlist/${courseId}`);
  },

  async isInWishlist(courseId: string): Promise<boolean> {
    const response = await api.get<ApiResponse<{ isInWishlist: boolean }>>(
      `/wishlist/check/${courseId}`,
    );
    return response.data.data!.isInWishlist;
  },

  async getWishlistIds(): Promise<string[]> {
    const response = await api.get<ApiResponse<string[]>>("/wishlist/ids");
    return response.data.data!;
  },
};
